import React from "react";

import { css } from "@emotion/css";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type BGMLoadMoreProps = {
  id?: string;
  text: string;
  loadMore: () => void;
};

export const BGMLoadMore: React.FC<BGMLoadMoreProps> = ({ id, text, loadMore }) => {
  const styles = useStyles(makeStyles);

  return (
    <TableRow id={id} className={styles.container} onClick={loadMore}>
      <TableCell colSpan={100}>
        <div className={styles.cell}>
          <Icons.plus className={styles.icon} />
          <Typography variant="body">{text}</Typography>
        </div>
      </TableCell>
    </TableRow>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    background-color: ${theme.palette.bgm.darkColumn};
    user-select: none;
    cursor: pointer;
    :hover {
      background-color: ${theme.palette.bgm.clearColumn};
    }
  `,
  cell: css`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  icon: css`
    margin-right: ${theme.spacing(2)};
    width: ${theme.typography.body.fontSize};
    height: ${theme.typography.body.fontSize};
  `,
});
